import * as React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';

interface Props {
    style?: React.CSSProperties;
    imageStyle?: React.CSSProperties;
    imageUrl?: string;
    width?: string;
    overlayImageUrl?: string;
    bingeImageUrl?: string;
    shouldShowCarousal?: boolean;
}

class GlanceThumbnail extends React.Component<Props, {}> {
    constructor(props: Props) {
        super(props);
    }

    render() {

            let glanceThumbnail = (
                <div width='100%' height='100%' key='glance-thumb-0'>
                    <img width={this.props.width ? this.props.width : '100%'}
                        src={this.props.imageUrl} title='Glance Thumbnail Comes here' style={this.props.imageStyle}/>
                </div>
            );
            let glanceThumbnailWithOverlay =
                this.props.overlayImageUrl ? (
                    <div width='100%' key='overlay-image-0'>
                            <span>
                                <img 
                                    src={this.props.imageUrl} style={{margin: 'auto', display: 'block', position:'relative', top:0, left:0}}/>
                                <img width='100%'
                                    src={this.props.overlayImageUrl} style={{margin: 'auto', display: 'block', position:'absolute', top:0, left:0}}/>
                            </span>
                        </div>
                ) : null;
            let bingeGlanceThumbnail = 
                this.props.bingeImageUrl ? (
                    <img width='100%' key='binge-image-0'
                        src={this.props.bingeImageUrl} style={this.props.imageStyle}/>    
                ) : null;

            let images = [];
            images.push(glanceThumbnail);
            if (glanceThumbnailWithOverlay != null && this.props.shouldShowCarousal) {
                images.push(glanceThumbnailWithOverlay);
            }
            if (bingeGlanceThumbnail != null && this.props.shouldShowCarousal) {
                images.push(bingeGlanceThumbnail);
            }

            return (
                <Carousel showThumbs={false} showStatus={false} autoPlay={true} infiniteLoop={true && this.props.shouldShowCarousal} showIndicators={false}>
                    {images}
                </Carousel>
            );
    }
}

export default GlanceThumbnail;



// WEBPACK FOOTER //
// ./src/pages/drafts/components/GlanceThumbnail.tsx